import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { AlertTriangle } from 'lucide-react';

const TT = { contentStyle: { background: '#16181d', border: '1px solid #2a2d33', borderRadius: 4, fontSize: 11 }, labelStyle: { color: '#e6e8ea' } };

// Exposé-SLA: one bar per day = exposés due, the on-time share inside; below: currently overdue deals.
export const SlaBars = ({ card }) => {
  const data = (card.bars || []).map((b) => ({ day: `${b.label} ${b.date}`, rechtzeitig: b.on_time, verspätet: Math.max(0, b.due - b.on_time) }));
  return (
    <div data-testid={`kpi-chart-${card.key}`}>
      <div className="h-[130px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 6, right: 8, bottom: 0, left: -22 }}>
            <XAxis dataKey="day" tick={{ fontSize: 8.5, fill: '#8a8f98' }} axisLine={false} tickLine={false} interval={0} />
            <YAxis tick={{ fontSize: 10, fill: '#8a8f98' }} axisLine={false} tickLine={false} allowDecimals={false} />
            <Tooltip {...TT} cursor={{ fill: 'rgba(255,255,255,0.04)' }} />
            <Legend wrapperStyle={{ fontSize: 9 }} iconSize={8} />
            <Bar dataKey="rechtzeitig" stackId="d" fill="#34d399" radius={[0, 0, 0, 0]} />
            <Bar dataKey="verspätet" stackId="d" fill="#f87171" radius={[2, 2, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      {(card.overdue_items || []).length > 0 && (
        <div className="mt-2 border border-red-500/30 rounded-sm divide-y divide-border/60" data-testid="kpi-sla-overdue-list">
          <p className="px-2 py-1 text-[9px] uppercase tracking-wider font-mono text-red-300 flex items-center gap-1">
            <AlertTriangle className="w-3 h-3" /> Aktuell überfällig ({card.overdue_items.length})
          </p>
          {card.overdue_items.map((it) => (
            <div key={it.id} className="px-2 py-1 flex items-center gap-2 text-[11px]" data-testid={`kpi-sla-overdue-${it.id}`}>
              <span className="text-muted-foreground truncate max-w-[40%]" title={it.broker}>{it.broker}</span>
              {it.project_id
                ? <Link to={`/projects/${it.project_id}`} className="text-foreground hover:text-amber-300 truncate">{it.name}</Link>
                : <Link to="/broker-inbox" className="text-foreground hover:text-amber-300 truncate">{it.name}</Link>}
              <span className="ml-auto font-mono text-red-300 whitespace-nowrap">{it.days_overdue} d</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
